export const months = [
    { mappedValue: 'january', label: 'January', value: '01' },
    { mappedValue: 'february', label: 'February', value: '02' },
    { mappedValue: 'march', label: 'March', value: '03' },
    { mappedValue: 'april', label: 'April', value: '04' },
    { mappedValue: 'may', label: 'May', value: '05' },
    { mappedValue: 'june', label: 'June', value: '06' },
    { mappedValue: 'july', label: 'July', value: '07' },
    { mappedValue: 'august', label: 'August', value: '08' },
    { mappedValue: 'september', label: 'September', value: '09' },
    { mappedValue: 'october', label: 'October', value: '10' },
    { mappedValue: 'november', label: 'November', value: '11' },
    { mappedValue: 'december', label: 'December', value: '12' }
];
